import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { getHelpTours, type HelpTour } from "@/lib/helpTours";
import { useAuth } from "@/hooks/useAuth";

export function useHelpTour() {
  const navigate = useNavigate();
  const { isSuperAdmin } = useAuth();

  const launchDriver = useCallback((steps: import("driver.js").DriveStep[]) => {
    const driverObj = driver({
      showProgress: true,
      animate: true,
      allowClose: true,
      overlayColor: "hsl(222 47% 11% / 0.6)",
      stagePadding: 8,
      stageRadius: 8,
      popoverClass: "mindsup-driver-popover",
      nextBtnText: "Suivant",
      prevBtnText: "Précédent",
      doneBtnText: "Terminer",
      progressText: "{{current}} / {{total}}",
      steps,
    });
    driverObj.drive();
  }, []);

  const startTour = useCallback(
    (tourKey: string) => {
      const tours = getHelpTours(isSuperAdmin);
      const tour = tours.find((t) => t.key === tourKey);
      if (!tour) return;

      navigate(tour.targetPath);
      setTimeout(() => launchDriver(tour.steps), 600);
    },
    [navigate, isSuperAdmin, launchDriver]
  );

  const startTourInPlace = useCallback(
    (tourKey: string) => {
      const tours = getHelpTours(isSuperAdmin);
      const tour = tours.find((t) => t.key === tourKey);
      if (!tour) return;

      // No navigation, launch immediately (small delay for DOM)
      setTimeout(() => launchDriver(tour.steps), 100);
    },
    [isSuperAdmin, launchDriver]
  );

  const getTours = useCallback((): HelpTour[] => {
    return getHelpTours(isSuperAdmin);
  }, [isSuperAdmin]);

  return { startTour, startTourInPlace, getTours };
}
